module.exports = __webpack_public_path__ + "2a1818ec8cf258290bfa5a1bc16aa53d.png";


//////////////////
// WEBPACK FOOTER
// ../images/brands/hero_default.png
// module id = 589
// module chunks = 69